import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import styled from "styled-components"
import PageTopTitle from "../../components/shared/PageTopTitle"
import { useSelector } from "react-redux"
import AdminSayfalarBox from "../../components/adminContainers/adminSayfaOlusturma/AdminSayfalarBox"
import AdminSayfaEkleInputContainer from "../../components/adminContainers/adminSayfaOlusturma/AdminSayfaEkleInputContainer"
import AdminMenuEkleInputContainer from "../../components/adminContainers/adminSayfaOlusturma/AdminMenuEkleInputContainer"

const Container = styled.div`
  width: 100%;
  height: 100%;
  .content{
    margin: 30px;
    display: flex;
    flex-direction: column;
    padding-bottom: 80px;
    .page-box{
        display: flex;
        justify-content: space-between;
        width: 70%;
    }
  }
`

const SayfaOlusturma = () => {
  const dispatch = useDispatch()
    const { selectedMenu } = useSelector((state) => state.admin5)

  return (
    <Container>
        <div className="wrapper">
            <PageTopTitle title={"Sayfa Oluşturma"} position="sticky" />

            <div className="content">
                <div className="page-box">
                    <AdminSayfalarBox />
                    {/* {selectedMenu && selectedMenu?.id === 0 && <AdminMenuEkleInputContainer />} */}
                    {selectedMenu && selectedMenu?.id !== 0 && <AdminSayfaEkleInputContainer />}
                </div>
            </div>

        </div>
    </Container>
  )
}

export default SayfaOlusturma